// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWorkItemByIdRequestModel from '../../model/get-work-item-by-id-request-model';
import GetWorkItemByIdRequestDTO from '../dto/get-work-item-by-id-request-dto';
import dtoSchema from '../schemas/get-work-item-by-id-request-schema';

export default abstract class GetWorkItemByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWorkItemByIdRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
      this.workItemId = data.workItemId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;
  /**
  * @type {int32}
  */
  workItemId?: number;

  static toModel(dto: DeepPartial<GetWorkItemByIdRequestDTO>): GetWorkItemByIdRequestModel;
  static toModel(dto: DeepPartial<GetWorkItemByIdRequestDTO> | undefined | null): GetWorkItemByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWorkItemByIdRequestDTO> | undefined | null): GetWorkItemByIdRequestModel | undefined {
    return dto ? new GetWorkItemByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWorkItemByIdRequestModel> | GetWorkItemByIdRequestModel): GetWorkItemByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
      workItemId: unwrapped.workItemId,
    } as GetWorkItemByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWorkItemByIdRequestModel, can not map to GetWorkItemByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
